import React from 'react'
import ThumbsUpImg from '../../assets/images/thumbs-up.png'
// import { getStudentFee } from '../../actions/StudentAction'
import { StateUseContext } from '../../context/UserDetailContext'
import TotalFeeInfoSection from './TotalFeeInfoSection'
import FeePaymentManage from './FeePaymentManage'

const CourseFeeSection = ({nexTabChange}) => {
    const {userDetail,feeDetail,feeLoader} = StateUseContext();
    // const {installment,lumpsum} = feeDetail !==undefined && feeDetail
    const {course_name} = userDetail !==undefined && userDetail


  return (
    <>
       { course_name ?
        <>
            {feeLoader ? 
            <div className="loading_section">
                <div className="spinner-grow" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>:
            <>
                {/* Scholarship info alert  */}
                {/* {feeDetail?.pending_amount > 1 && */}
                <>
                    {feeDetail?.scholarship_percentage > 0 && 
                    <div className="scholarship_percentage_infoWrap mt-4 d-flex align-items-center">
                        <img src={ThumbsUpImg} alt="thumbs up icon"/>
                        <div className="inner_itemWrap">
                            <h4> <span className="text-primary fw-bold">Enjoy {feeDetail?.scholarship_percentage}% off </span>on Your Tuition Fee Payment</h4>
                            <p>Congratulation! You have saved <b>{parseFloat(feeDetail?.total_fee - feeDetail?.net_payable_amount).toFixed(2)} {feeDetail?.currency_code}</b> </p>
                        </div>
                    </div>
                    }

                    {/* To Show total fee  */}
                    
                    <TotalFeeInfoSection feeDetail={feeDetail !==undefined && feeDetail} userDetail={userDetail !==undefined && userDetail}/>
                   
                </>

                {(userDetail?.pending_approve <= 0 && userDetail?.pending_approve !==null) && 
                <div className='feePaid_msgWrapper text-center p-4 rounded mt-4' style={{maxWidth:'100%'}}>
                    <h3>Thank You</h3>
                    <p>No outstanding balance is due for payment. your fee has been fully settled.</p>
                </div>    
                }

                {/* Choose payment option  and installment listing view*/}
              
                <FeePaymentManage  feeDetail={feeDetail !==undefined && feeDetail} userDetail={userDetail !==undefined && userDetail}/>
                
                <button className="btn btn-default mt-4" onClick={e => nexTabChange()} type="button">Next</button>
            </>
        }
            </>
        : 
        <div className="text-start">
        <h5 className='badge ms-auto text-center fs-6 bg-warning-subtle text-dark mt-5  py-4 px-5 fw-bold'>* Please select your course</h5>
        </div>
    }
        </>

  )
}

export default CourseFeeSection